import { useEffect, useRef } from 'react';

/** Calls `onClose` when any ancestor element scrolls. Uses capture-phase listener on window. */
export const CloseOnScroll = ({ onClose }: { onClose: () => void }) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    const handler = () => onCloseRef.current();
    window.addEventListener('scroll', handler, true);
    return () => window.removeEventListener('scroll', handler, true);
  }, []);

  return null;
};
